import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";

export default function RequireAuth({ children }) {
  const { user, loading } = useAuthContext();
  const location = useLocation();

  if (!loading && !user) {
    return <div style={{ height: "100vh" }}></div>;
  }

  return children;
}
